import { Select, SelectProps } from 'antd';
import { FC } from 'react';
import { SpecialtyListItem } from 'types/api/specialties';

interface IProps extends Omit<SelectProps, 'options' | 'mode'> {
  options: SpecialtyListItem[];
}

/**
 * Presentational only — the catalog is fetched once by the page and split
 * into the symptom/specialty halves there, because the prefill needs the
 * same id sets to work out which picker each attached relation belongs to.
 */
const SpecialtySelect: FC<IProps> = ({ options, ...rest }) => (
  <Select
    {...rest}
    mode="multiple"
    style={{ width: '100%' }}
    optionFilterProp="label"
    options={options.map(item => ({ label: item.name, value: item.id }))}
  />
);

export default SpecialtySelect;
